module.exports = __webpack_public_path__ + "static/media/trimex_fresa.c6864fba.png";